var map = {
	"./gbd/pages/1-byName/page-similarname.module": [
		5852,
		"src_app_gbd_pages_1-byName_page-similarname_module_ts"
	],
	"./gdd/pages/1-byName/page-similarname.module": [
		72858,
		"src_app_gdd_pages_1-byName_page-similarname_module_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19089;
module.exports = webpackAsyncContext;